export default "__VITE_ASSET__rLnJG0JZ__"